import React, {Fragment, useState} from 'react'
import {Spin} from 'antd'
import TableHead from './data/TableHead'
import TableRow from './data/TableRow'
import emptyData from '../../../assets/images/empty-img-gray.png'
import SettingShippingCarrierPagination from "./SettingShippingCarrierPagination"

const SettingShippingCarrierTable = (props) => {
    const {loading, shippingCarriers, onShowHistory, onCloseHistory} = props
    const [loadingSend, _setLoadingSend] = useState(false)

    return (
        <div className="ShippingRuleTable">
            <Spin spinning={loading} tip='Loading...'>
                {shippingCarriers.length > 0 ? (
                    <div>
                        <table className='table'>
                            <TableHead/>
                            <tbody className="TableBody">
                            {
                                shippingCarriers.map(shippingCarrier => {
                                    return (
                                        <Fragment key={shippingCarrier._id}>
                                            <TableRow
                                                loadingSend={loadingSend}
                                                handleSendLoading={_setLoadingSend}
                                                shippingCarrier={shippingCarrier}
                                                currentPage={1}
                                                onShowHistory={onShowHistory}
                                                onCloseHistory={onCloseHistory}
                                            />
                                        </Fragment>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        <SettingShippingCarrierPagination {...props}/>
                    </div>
                ) : !loading && (
                    <div className="noData d-flex flex-column align-items-center justify-content-center">
                        <img src={emptyData} alt="No data"/>
                        No data!
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default SettingShippingCarrierTable
